export type Lang = "es" | "gl" | "en";

export const LANGS: { id: Lang; label: string; native: string }[] = [
  { id: "es", label: "Español", native: "ES" },
  { id: "gl", label: "Galego", native: "GL" },
  { id: "en", label: "English", native: "EN" },
];

export const DATE_LOCALES: Record<Lang, string> = {
  es: "es-ES",
  gl: "gl-ES",
  en: "en-GB",
};

const es = {
  meta: {
    description:
      "Podólogo en Pontedeume — PontePie, clínica podológica con Cristina Vila Portela. Reserva cita, servicios y contacto.",
    homeTitle: "PontePie - Clínica podológica en Pontedeume",
    aboutTitle: "Podólogo en Pontedeume | Sobre PontePie",
    servicesTitle: "Podólogo en Pontedeume | Servicios de podología",
    bookTitle: "Reservar cita | Podólogo Pontedeume — PontePie",
    contactTitle: "Contacto | Podólogo en Pontedeume — PontePie",
    notFoundTitle: "Página no encontrada | PontePie",
    privacyTitle: "Política de privacidad",
    legalTitle: "Aviso legal | PontePie",
    cookiesTitle: "Política de cookies",
  },
  nav: {
    skip: "Saltar al contenido",
    home: "Inicio PontePie",
    about: "PontePie",
    aboutTitle: "Sobre PontePie",
    services: "Servicios",
    book: "Pedir cita",
    contact: "Contacto",
    openMenu: "Abrir menú",
    closeMenu: "Cerrar menú",
    main: "Principal",
    language: "Idioma",
  },
  footer: {
    tagline: "Clínica podológica · Pontedeume",
    facebook: "PontePie en Facebook (se abre en una pestaña nueva)",
    instagram: "PontePie en Instagram (se abre en una pestaña nueva)",
    whatsapp: "Contactar por WhatsApp",
    maps: "Ver ubicación en Google Maps (se abre en una pestaña nueva)",
    waMessage: "Hola, quería preguntarle una duda",
    logoAlt: "Logotipo PontePie",
    legalNav: "Información legal",
    privacy: "Privacidad",
    legal: "Aviso legal",
    cookies: "Cookies",
  },
  index: {
    title: "PontePie - Clínica podológica en Pontedeume",
    lead: "PontePie — clínica podológica con Cristina Vila Portela",
    book: "Reservar cita",
    services: "Ver servicios",
    colegiada: "N.º colegiada: 1193",
    photoClinic: "Interior de la clínica PontePie",
    photoCare: "Atención podológica a una persona",
    hours: "Horario",
    hoursLead: "Cita previa · Pontedeume",
    monThu: "Lunes a jueves",
    friday: "Viernes",
    morning: "Mañana",
    afternoon: "Tarde",
    closed: "Cerrado",
    bookOnline: "Reservar cita online",
  },
  services: {
    title: "Servicios de PontePie",
    intro:
      "Elige el tipo de visita que necesitas. Desde aquí puedes iniciar la reserva con el servicio ya preseleccionado.",
    duration: "Duración orientativa: {duration}",
    bookThis: "Reservar este servicio",
    primera: {
      title: "Primera consulta",
      desc: "Evaluación completa, estudio de la pisada y plan inicial personalizado.",
    },
    consulta: {
      title: "Consulta / revisión",
      desc: "Seguimiento de evolución, ajuste de tratamiento y recomendaciones.",
    },
    tratamiento: {
      title: "Tratamiento",
      desc: "Sesión de tratamiento para resolver molestias y recuperar movilidad.",
    },
  },
  about: {
    title: "Sobre PontePie",
    lead:
      "Clínica podológica en Pontedeume, enfocada en el cuidado del pie y la calidad de vida de cada persona.",
    p1: "PontePie nace de la vocación por ofrecer una atención cercana, basada en evidencia y adaptada a tus necesidades. Trabajamos con un enfoque integral: evaluación, tratamiento y seguimiento para que recuperes comodidad y confianza al caminar.",
    p2before: "La clínica está dirigida por",
    p2after:
      "(n.º colegiada 1193), con formación continua y especial interés en la prevención y el acompañamiento del paciente.",
    p3: "Si quieres conocer los tipos de visita o reservar cita, puedes hacerlo de forma sencilla desde la web.",
    services: "Ver servicios",
    book: "Reservar cita",
  },
  contact: {
    title: "Contacto",
    intro:
      "PontePie — clínica podológica en Pontedeume. Escríbenos o reserva cita online cuando te venga bien.",
    location: "Ubicación",
    addressName: "Clínica podológica PontePie",
    addressStreet: "Avda. Dr. Villanueva, 36, Portal 1, 1ºA",
    addressCity: "15600 Pontedeume (A Coruña)",
    maps: "Abrir en Google Maps",
    social: "Redes y WhatsApp",
    email: "Email",
    hours: "Horario de atención",
    hoursMonThu: "Lunes a jueves:",
    hoursMonThuDetail: "mañanas 10:00–14:00, tardes 16:00–20:00.",
    hoursFri: "Viernes:",
    hoursFriDetail: "mañanas 10:00–15:00.",
    bookTitle: "Pedir cita",
    bookText: "La forma más rápida es reservar online con el asistente.",
    bookLink: "Ir a reservar cita",
    bookCta: "Reservar cita",
    waMessage: "Hola, quería consultar una duda",
  },
  cita: {
    title: "Reserva tu cita en PontePie",
    introBefore: "Tres pasos: servicio, fecha y hora, y tus datos. Al confirmar recibirás un",
    locator: "localizador",
    introAfter: "para gestionar la cita cuando lo necesites.",
    rail: "Resumen del asistente",
    stepService: "Servicio",
    stepWhen: "Fecha y hora",
    stepData: "Tus datos",
    stepDone: "Confirmación",
    wizard: "Asistente de reserva",
    stepOf: "Paso {step} de 3",
    confirmed: "Cita confirmada",
    progress: "Progreso de la reserva",
    progressPct: "{pct}% completado",
    chooseService: "1. Elige el servicio",
    chooseServiceHint: "Selecciona una opción. Puedes cambiarla más adelante volviendo a este paso.",
    loadingServices: "Cargando servicios…",
    continueWhen: "Continuar con fecha y hora",
    chooseWhen: "2. Elige fecha y hora",
    serviceLabel: "Servicio:",
    calendar: "Calendario",
    datePicker: "Selector de fecha",
    loadingSlots: "Cargando horarios…",
    emptyTitle: "No hay citas libres este día",
    emptyText:
      "Prueba otra fecha en el calendario o vuelve más tarde. Si la molestia es urgente, llámanos o escríbenos desde contacto.",
    slotsGroup: "Horarios disponibles",
    back: "Volver",
    continueData: "Continuar con tus datos",
    confirmData: "3. Confirma tus datos",
    formHintBefore: "Los campos marcados con",
    formHintAfter: "son obligatorios. Indica al menos email o teléfono.",
    returningTitle: "¿Ya has reservado antes?",
    returningIntro:
      "No hace falta crear una cuenta. Si ya eres paciente, busca tus datos con el email o teléfono y el apellido que usaste, o recupera lo guardado en este dispositivo.",
    returningSaved: "En este dispositivo hay datos guardados de {name}.",
    returningUseSaved: "Usar estos datos",
    returningNotMe: "No soy yo",
    returningContact: "Email o teléfono",
    returningContactPlaceholder: "ej. nombre@correo.com o 600123456",
    returningLastName: "Apellido",
    returningSearch: "Buscar mis datos",
    returningFound: "Datos encontrados. Revisa el formulario y confirma la cita.",
    returningApplied: "Hemos rellenado el formulario con los datos de este dispositivo.",
    errLookupNeed: "Indica email o teléfono y el apellido para buscar.",
    errLookup: "No se pudieron buscar los datos",
    firstName: "Nombre",
    lastName: "Apellidos",
    email: "Email",
    phone: "Teléfono",
    notes: "Comentarios",
    optional: "(opcional)",
    confirming: "Confirmando…",
    confirm: "Confirmar cita",
    successTitle: "Reserva confirmada",
    successIntro: "Hemos registrado tu cita. Anota o guarda captura de tu localizador:",
    locatorAria: "Localizador {code}",
    successHint: "Lo necesitarás para cancelar o reprogramar desde esta misma página, más abajo.",
    summaryService: "Servicio",
    summaryWhen: "Fecha y hora",
    summaryStatus: "Estado",
    bookAnother: "Reservar otra cita",
    manageTitle: "Gestionar una cita existente",
    manageIntro:
      "Introduce el localizador y el apellido de la reserva. Para reprogramar, primero carga los huecos libres (mismo calendario que al reservar) y elige hora. Para cancelar, puedes usar el botón con o sin cargar horarios.",
    manageLocator: "Localizador",
    manageLastName: "Apellido",
    cancelReason: "Motivo de cancelación",
    looking: "Buscando…",
    loadSlots: "Ver horarios para reprogramar",
    found: "Cita localizada",
    currentDate: "Fecha actual",
    cannotReschedule:
      "No se puede reprogramar una cita cancelada. Puedes reservar una cita nueva desde el asistente superior.",
    newWhen: "Nueva fecha y hora",
    sameType: "Solo se muestran huecos libres para el mismo tipo de visita que tu cita actual.",
    emptyReschedule:
      "Prueba otra fecha en el calendario. Tu hueco actual no cuenta como ocupado al buscar nueva hora.",
    rescheduleReason: "Motivo de la reprogramación",
    reschedulePlaceholder: "Ej.: imprevisto de trabajo, cambio de disponibilidad…",
    processing: "Procesando…",
    cancelBtn: "Cancelar cita",
    rescheduleBtn: "Reprogramar cita",
    errNetwork: "Error de red",
    errServices: "No se pudieron cargar los servicios",
    errSlots: "No se pudo cargar la disponibilidad",
    errPreview: "No se pudo verificar la cita",
    errNeedLocator: "Debes indicar localizador y apellido para cargar horarios.",
    errName: "Nombre y apellidos son obligatorios.",
    errContact: "Debes indicar al menos email o teléfono.",
    errNeedSlot: "Selecciona un horario antes de confirmar.",
    errBook: "No se pudo completar la reserva",
    errNeedManage: "Debes indicar localizador y apellido.",
    errNeedNewSlot: "Carga los horarios disponibles y elige una nueva fecha y hora.",
    errCancel: "No se pudo cancelar la cita",
    errReschedule: "No se pudo reprogramar la cita",
    errManage: "No se pudo gestionar la cita",
    cancelledOk: "Cita {code} cancelada correctamente.",
    rescheduledOk: "Cita {code} reprogramada para {when}.",
    privacyConsent:
      "He leído la información de privacidad y consiento el tratamiento de mis datos para gestionar la cita.",
    privacyPrefix: "Puedes consultar la",
    privacyLink: "política de privacidad",
    errPrivacy: "Debes aceptar la información de privacidad para confirmar la cita.",
    errEmail: "El email no tiene un formato válido.",
    companyHoneypot: "No rellenar",
  },
  notFound: {
    title: "No encontramos esta página",
    body: "La dirección no existe o ha cambiado. Vuelve al inicio para reservar cita o consultar servicios.",
    home: "Volver al inicio",
  },
  legal: {
    metaDesc:
      "Política de privacidad, aviso legal y cookies de PontePie, clínica podológica en Pontedeume.",
    lastUpdated: "Última actualización: 28 de agosto de 2026.",
    intro:
      "PontePie es la consulta de podología de Cristina Vila Portela en Pontedeume. Estos textos identifican al responsable, el uso de datos y las condiciones de la web.",
    privacyH1: "Política de privacidad",
    noticeH1: "Aviso legal",
    cookiesH1: "Política de cookies",
    controller: "Responsable del tratamiento",
    controllerBody:
      "{name} (nombre comercial {trade}), colegiada n.º {collegiate} del {college}. Domicilio profesional: {address}. Teléfono: {phone}. Email de privacidad: {email}. Registro sanitario: {sanitary}.",
    nifKnown: "NIF: {nif}.",
    nifUnknown:
      "El NIF de la titular consta en las facturas y se facilita a las autoridades y a quien lo solicite de forma justificada en {email}. No se publica aquí porque no figura en fuentes abiertas.",
    purpose: "Finalidad",
    purposeBody:
      "Gestionar citas, contacto y, cuando reserva o acude a consulta, la historia clínica asociada a su atención (datos de salud). También enviamos confirmación, cancelación y recordatorio de cita si nos ha dejado un email.",
    legalBasis: "Base jurídica",
    legalBasisBody:
      "Prestación del servicio sanitario y medidas precontractuales (reserva). Consentimiento que marca en el formulario de cita. Obligaciones legales de historia clínica y facturación.",
    rights: "Derechos",
    rightsBody:
      "Puede solicitar acceso, rectificación, supresión, limitación, portabilidad u oposición en {email}. También puede reclamar ante la Agencia Española de Protección de Datos (aepd.es).",
    retention: "Conservación",
    retentionBody:
      "La historia clínica se conserva como mínimo 5 años desde la última asistencia, conforme a la Ley 41/2002. Los datos de citas y contacto se conservan el tiempo necesario para la agenda, reclamaciones y obligaciones fiscales (en general, hasta 5 años).",
    processors: "Encargados del tratamiento",
    processorsBody:
      "Alojamiento de base de datos: Neon (PostgreSQL). Si hay correo configurado, el envío es por SMTP. No vendemos sus datos ni hacemos publicidad comportamental.",
    transfers: "Transferencias internacionales",
    transfersBody:
      "Neon puede alojar la base en la Unión Europea o en otra región según el proyecto. No enviamos datos a servicios de analítica publicitaria.",
    owner: "Titular del sitio",
    ownerBody:
      "El sitio {site} es titularidad de {name}, que ejerce como {trade}. Domicilio: {address}. Email: {email}. Teléfono: {phone}. N.º de colegiada: {collegiate} ({college}). Registro sanitario: {sanitary}.",
    sanitary: "Autorización sanitaria",
    sanitaryBody:
      "Consulta de podología con número de registro sanitario {sanitary} (Galicia).",
    liability: "Responsabilidad",
    liabilityBody:
      "La información de la web es orientativa y no sustituye una consulta presencial. La disponibilidad de huecos puede cambiar hasta confirmar la reserva. Queda prohibido el uso de contenidos con fines distintos a informarse o reservar cita.",
    cookiesWhat: "Tecnologías que usamos",
    cookiesBody:
      "No usamos cookies de publicidad ni analítica de marketing. Solo almacenamiento local necesario para el idioma, el aviso de cookies y la sesión del panel interno.",
    cookiesList: "Detalle",
    cookieLang: "pontepie_lang: idioma de la interfaz (necesario).",
    cookieAdmin: "pontepie_admin_token: sesión del personal en /admin (necesario para el panel).",
    cookieConsent: "pontepie_cookie_consent: recuerda si ha aceptado el aviso de cookies (necesario).",
    cookieSentry:
      "Sentry: diagnóstico de errores en producción. No se usa para publicidad. Puede incluir identificadores técnicos del navegador.",
  },
  cookieBanner: {
    message:
      "Usamos cookies propias para el funcionamiento de la web (idioma, aviso de cookies y, si aplica, sesión del panel). Puede consultar más información en nuestra",
    accept: "Aceptar",
    policy: "política de cookies",
  },
  status: {
    pending: "Pendiente",
    confirmed: "Confirmada",
    cancelled: "Cancelada",
    completed: "Completada",
    no_show: "No presentada",
  },
};

export type Dict = typeof es;

const gl: Dict = {
  meta: {
    description:
      "Podólogo en Pontedeume — PontePie, clínica podolóxica con Cristina Vila Portela. Reserva cita, servizos e contacto.",
    homeTitle: "PontePie - Clínica podolóxica en Pontedeume",
    aboutTitle: "Podólogo en Pontedeume | Sobre PontePie",
    servicesTitle: "Podólogo en Pontedeume | Servizos de podoloxía",
    bookTitle: "Reservar cita | Podólogo Pontedeume — PontePie",
    contactTitle: "Contacto | Podólogo en Pontedeume — PontePie",
    notFoundTitle: "Páxina non atopada | PontePie",
    privacyTitle: "Política de privacidade",
    legalTitle: "Aviso legal | PontePie",
    cookiesTitle: "Política de cookies",
  },
  nav: {
    skip: "Saltar ao contido",
    home: "Inicio PontePie",
    about: "PontePie",
    aboutTitle: "Sobre PontePie",
    services: "Servizos",
    book: "Pedir cita",
    contact: "Contacto",
    openMenu: "Abrir menú",
    closeMenu: "Pechar menú",
    main: "Principal",
    language: "Idioma",
  },
  footer: {
    tagline: "Clínica podolóxica · Pontedeume",
    facebook: "PontePie en Facebook (ábrese nunha lapela nova)",
    instagram: "PontePie en Instagram (ábrese nunha lapela nova)",
    whatsapp: "Contactar por WhatsApp",
    maps: "Ver localización en Google Maps (ábrese nunha lapela nova)",
    waMessage: "Ola, quería preguntarlle unha dúbida",
    logoAlt: "Logotipo PontePie",
    legalNav: "Información legal",
    privacy: "Privacidade",
    legal: "Aviso legal",
    cookies: "Cookies",
  },
  index: {
    title: "PontePie - Clínica podolóxica en Pontedeume",
    lead: "PontePie — clínica podolóxica con Cristina Vila Portela",
    book: "Reservar cita",
    services: "Ver servizos",
    colegiada: "N.º colexiada: 1193",
    photoClinic: "Interior da clínica PontePie",
    photoCare: "Atención podolóxica a unha persoa",
    hours: "Horario",
    hoursLead: "Cita previa · Pontedeume",
    monThu: "Luns a xoves",
    friday: "Venres",
    morning: "Mañá",
    afternoon: "Tarde",
    closed: "Pechado",
    bookOnline: "Reservar cita en liña",
  },
  services: {
    title: "Servizos de PontePie",
    intro:
      "Escolle o tipo de visita que necesitas. Desde aquí podes iniciar a reserva co servizo xa preseleccionado.",
    duration: "Duración orientativa: {duration}",
    bookThis: "Reservar este servizo",
    primera: {
      title: "Primeira consulta",
      desc: "Avaliación completa, estudo da pisada e plan inicial personalizado.",
    },
    consulta: {
      title: "Consulta / revisión",
      desc: "Seguimento da evolución, axuste do tratamento e recomendacións.",
    },
    tratamiento: {
      title: "Tratamento",
      desc: "Sesión de tratamento para resolver molestias e recuperar mobilidade.",
    },
  },
  about: {
    title: "Sobre PontePie",
    lead:
      "Clínica podolóxica en Pontedeume, enfocada no coidado do pé e na calidade de vida de cada persoa.",
    p1: "PontePie nace da vocación por ofrecer unha atención próxima, baseada en evidencia e adaptada ás túas necesidades. Traballamos cun enfoque integral: avaliación, tratamento e seguimento para que recuperes comodidade e confianza ao camiñar.",
    p2before: "A clínica está dirixida por",
    p2after:
      "(n.º colexiada 1193), con formación continua e especial interese na prevención e no acompañamento da persoa paciente.",
    p3: "Se queres coñecer os tipos de visita ou reservar cita, podes facelo de forma sinxela desde a web.",
    services: "Ver servizos",
    book: "Reservar cita",
  },
  contact: {
    title: "Contacto",
    intro:
      "PontePie — clínica podolóxica en Pontedeume. Escríbenos ou reserva cita en liña cando che veña ben.",
    location: "Localización",
    addressName: "Clínica podolóxica PontePie",
    addressStreet: "Avda. Dr. Villanueva, 36, Portal 1, 1ºA",
    addressCity: "15600 Pontedeume (A Coruña)",
    maps: "Abrir en Google Maps",
    social: "Redes e WhatsApp",
    email: "Email",
    hours: "Horario de atención",
    hoursMonThu: "Luns a xoves:",
    hoursMonThuDetail: "mañás 10:00–14:00, tardes 16:00–20:00.",
    hoursFri: "Venres:",
    hoursFriDetail: "mañás 10:00–15:00.",
    bookTitle: "Pedir cita",
    bookText: "A forma máis rápida é reservar en liña co asistente.",
    bookLink: "Ir a reservar cita",
    bookCta: "Reservar cita",
    waMessage: "Ola, quería consultar unha dúbida",
  },
  cita: {
    title: "Reserva a túa cita en PontePie",
    introBefore: "Tres pasos: servizo, data e hora, e os teus datos. Ao confirmar recibirás un",
    locator: "localizador",
    introAfter: "para xestionar a cita cando o necesites.",
    rail: "Resumo do asistente",
    stepService: "Servizo",
    stepWhen: "Data e hora",
    stepData: "Os teus datos",
    stepDone: "Confirmación",
    wizard: "Asistente de reserva",
    stepOf: "Paso {step} de 3",
    confirmed: "Cita confirmada",
    progress: "Progreso da reserva",
    progressPct: "{pct}% completado",
    chooseService: "1. Escolle o servizo",
    chooseServiceHint: "Selecciona unha opción. Podes cambiala máis adiante volvendo a este paso.",
    loadingServices: "Cargando servizos…",
    continueWhen: "Continuar con data e hora",
    chooseWhen: "2. Escolle data e hora",
    serviceLabel: "Servizo:",
    calendar: "Calendario",
    datePicker: "Selector de data",
    loadingSlots: "Cargando horarios…",
    emptyTitle: "Non hai citas libres este día",
    emptyText:
      "Proba outra data no calendario ou volve máis tarde. Se a molestia é urxente, chámanos ou escríbenos desde contacto.",
    slotsGroup: "Horarios dispoñibles",
    back: "Volver",
    continueData: "Continuar cos teus datos",
    confirmData: "3. Confirma os teus datos",
    formHintBefore: "Os campos marcados con",
    formHintAfter: "son obrigatorios. Indica polo menos email ou teléfono.",
    returningTitle: "Xa reservaches antes?",
    returningIntro:
      "Non fai falta crear unha conta. Se xa es paciente, busca os teus datos co email ou teléfono e o apelido que usaches, ou recupera o gardado neste dispositivo.",
    returningSaved: "Neste dispositivo hai datos gardados de {name}.",
    returningUseSaved: "Usar estes datos",
    returningNotMe: "Non son eu",
    returningContact: "Email ou teléfono",
    returningContactPlaceholder: "ex. nome@correo.com ou 600123456",
    returningLastName: "Apelido",
    returningSearch: "Buscar os meus datos",
    returningFound: "Datos atopados. Revisa o formulario e confirma a cita.",
    returningApplied: "Enchemos o formulario cos datos deste dispositivo.",
    errLookupNeed: "Indica email ou teléfono e o apelido para buscar.",
    errLookup: "Non se puideron buscar os datos",
    firstName: "Nome",
    lastName: "Apelidos",
    email: "Email",
    phone: "Teléfono",
    notes: "Comentarios",
    optional: "(opcional)",
    confirming: "Confirmando…",
    confirm: "Confirmar cita",
    successTitle: "Reserva confirmada",
    successIntro: "Rexistramos a túa cita. Anota ou garda captura do teu localizador:",
    locatorAria: "Localizador {code}",
    successHint: "Necesitaralo para cancelar ou reprogramar desde esta mesma páxina, máis abaixo.",
    summaryService: "Servizo",
    summaryWhen: "Data e hora",
    summaryStatus: "Estado",
    bookAnother: "Reservar outra cita",
    manageTitle: "Xestionar unha cita existente",
    manageIntro:
      "Introduce o localizador e o apelido da reserva. Para reprogramar, primeiro carga os ocos libres (o mesmo calendario que ao reservar) e escolle hora. Para cancelar, podes usar o botón con ou sen cargar horarios.",
    manageLocator: "Localizador",
    manageLastName: "Apelido",
    cancelReason: "Motivo de cancelación",
    looking: "Buscando…",
    loadSlots: "Ver horarios para reprogramar",
    found: "Cita localizada",
    currentDate: "Data actual",
    cannotReschedule:
      "Non se pode reprogramar unha cita cancelada. Podes reservar unha cita nova desde o asistente superior.",
    newWhen: "Nova data e hora",
    sameType: "Só se mostran ocos libres para o mesmo tipo de visita que a túa cita actual.",
    emptyReschedule:
      "Proba outra data no calendario. O teu oco actual non conta como ocupado ao buscar nova hora.",
    rescheduleReason: "Motivo da reprogramación",
    reschedulePlaceholder: "Ex.: imprevisto de traballo, cambio de dispoñibilidade…",
    processing: "Procesando…",
    cancelBtn: "Cancelar cita",
    rescheduleBtn: "Reprogramar cita",
    errNetwork: "Erro de rede",
    errServices: "Non se puideron cargar os servizos",
    errSlots: "Non se puido cargar a dispoñibilidade",
    errPreview: "Non se puido verificar a cita",
    errNeedLocator: "Debes indicar localizador e apelido para cargar horarios.",
    errName: "Nome e apelidos son obrigatorios.",
    errContact: "Debes indicar polo menos email ou teléfono.",
    errNeedSlot: "Selecciona un horario antes de confirmar.",
    errBook: "Non se puido completar a reserva",
    errNeedManage: "Debes indicar localizador e apelido.",
    errNeedNewSlot: "Carga os horarios dispoñibles e escolle unha nova data e hora.",
    errCancel: "Non se puido cancelar a cita",
    errReschedule: "Non se puido reprogramar a cita",
    errManage: "Non se puido xestionar a cita",
    cancelledOk: "Cita {code} cancelada correctamente.",
    rescheduledOk: "Cita {code} reprogramada para {when}.",
    privacyConsent:
      "Lin a información de privacidade e consinto o tratamento dos meus datos para xestionar a cita.",
    privacyPrefix: "Podes consultar a",
    privacyLink: "política de privacidade",
    errPrivacy: "Debes aceptar a información de privacidade para confirmar a cita.",
    errEmail: "O email non ten un formato válido.",
    companyHoneypot: "Non encher",
  },
  notFound: {
    title: "Non atopamos esta páxina",
    body: "O enderezo non existe ou cambiou. Volve ao inicio para reservar cita ou consultar servizos.",
    home: "Volver ao inicio",
  },
  legal: {
    metaDesc:
      "Política de privacidade, aviso legal e cookies de PontePie, clínica podolóxica en Pontedeume.",
    lastUpdated: "Última actualización: 28 de agosto de 2026.",
    intro:
      "PontePie é a consulta de podoloxía de Cristina Vila Portela en Pontedeume. Estes textos identifican a responsable, o uso de datos e as condicións da web.",
    privacyH1: "Política de privacidade",
    noticeH1: "Aviso legal",
    cookiesH1: "Política de cookies",
    controller: "Responsable do tratamento",
    controllerBody:
      "{name} (nome comercial {trade}), colexiada n.º {collegiate} do {college}. Domicilio profesional: {address}. Teléfono: {phone}. Email de privacidade: {email}. Rexistro sanitario: {sanitary}.",
    nifKnown: "NIF: {nif}.",
    nifUnknown:
      "O NIF da titular figura nas facturas e facilítase ás autoridades e a quen o solicite de forma xustificada en {email}. Non se publica aquí porque non consta en fontes abertas.",
    purpose: "Finalidade",
    purposeBody:
      "Xestionar citas, contacto e, cando reserva ou acode a consulta, a historia clínica asociada á súa atención (datos de saúde). Tamén enviamos confirmación, cancelación e recordatorio de cita se nos deixou un email.",
    legalBasis: "Base xurídica",
    legalBasisBody:
      "Prestación do servizo sanitario e medidas precontractuais (reserva). Consentimento que marca no formulario de cita. Obrigas legais de historia clínica e facturación.",
    rights: "Dereitos",
    rightsBody:
      "Pode solicitar acceso, rectificación, supresión, limitación, portabilidade ou oposición en {email}. Tamén pode reclamar ante a Axencia Española de Protección de Datos (aepd.es).",
    retention: "Conservación",
    retentionBody:
      "A historia clínica consérvase como mínimo 5 anos desde a última asistencia, conforme á Lei 41/2002. Os datos de citas e contacto consérvanse o tempo necesario para a axenda, reclamacións e obrigas fiscais (en xeral, ata 5 anos).",
    processors: "Encargados do tratamento",
    processorsBody:
      "Aloxamento da base de datos: Neon (PostgreSQL). Se hai correo configurado, o envío é por SMTP. Non vendemos os seus datos nin facemos publicidade comportamental.",
    transfers: "Transferencias internacionais",
    transfersBody:
      "Neon pode aloxar a base na Unión Europea ou noutra rexión segundo o proxecto. Non enviamos datos a servizos de analítica publicitaria.",
    owner: "Titular do sitio",
    ownerBody:
      "O sitio {site} é titularidade de {name}, que exerce como {trade}. Domicilio: {address}. Email: {email}. Teléfono: {phone}. N.º de colexiada: {collegiate} ({college}). Rexistro sanitario: {sanitary}.",
    sanitary: "Autorización sanitaria",
    sanitaryBody:
      "Consulta de podoloxía co número de rexistro sanitario {sanitary} (Galicia).",
    liability: "Responsabilidade",
    liabilityBody:
      "A información da web é orientativa e non substitúe unha consulta presencial. A dispoñibilidade de ocos pode cambiar ata confirmar a reserva. Queda prohibido o uso de contidos con fins distintos de informarse ou reservar cita.",
    cookiesWhat: "Tecnoloxías que usamos",
    cookiesBody:
      "Non usamos cookies de publicidade nin analítica de márketing. Só almacenamento local necesario para o idioma e a sesión do panel interno.",
    cookiesList: "Detalle",
    cookieLang: "pontepie_lang: idioma da interface (necesario).",
    cookieAdmin: "pontepie_admin_token: sesión do persoal en /admin (necesario para o panel).",
    cookieConsent: "pontepie_cookie_consent: lembra se aceptou o aviso de cookies (necesario).",
    cookieSentry:
      "Sentry: diagnóstico de erros en produción. Non se usa para publicidade. Pode incluír identificadores técnicos do navegador.",
  },
  cookieBanner: {
    message:
      "Usamos cookies propias para o funcionamento da web (idioma, aviso de cookies e, se aplica, sesión do panel). Pode consultar máis información na nosa",
    accept: "Aceptar",
    policy: "política de cookies",
  },
  status: {
    pending: "Pendente",
    confirmed: "Confirmada",
    cancelled: "Cancelada",
    completed: "Completada",
    no_show: "Non presentada",
  },
};

const en: Dict = {
  meta: {
    description:
      "Podiatrist in Pontedeume — PontePie, podiatry clinic with Cristina Vila Portela. Book an appointment, services and contact.",
    homeTitle: "PontePie - Podiatry clinic in Pontedeume",
    aboutTitle: "Podiatrist in Pontedeume | About PontePie",
    servicesTitle: "Podiatrist in Pontedeume | Podiatry services",
    bookTitle: "Book an appointment | Podiatrist Pontedeume — PontePie",
    contactTitle: "Contact | Podiatrist in Pontedeume — PontePie",
    notFoundTitle: "Page not found | PontePie",
    privacyTitle: "Privacy policy",
    legalTitle: "Legal notice | PontePie",
    cookiesTitle: "Cookie policy",
  },
  nav: {
    skip: "Skip to content",
    home: "PontePie home",
    about: "PontePie",
    aboutTitle: "About PontePie",
    services: "Services",
    book: "Book appointment",
    contact: "Contact",
    openMenu: "Open menu",
    closeMenu: "Close menu",
    main: "Main",
    language: "Language",
  },
  footer: {
    tagline: "Podiatry clinic · Pontedeume",
    facebook: "PontePie on Facebook (opens in a new tab)",
    instagram: "PontePie on Instagram (opens in a new tab)",
    whatsapp: "Contact via WhatsApp",
    maps: "View location on Google Maps (opens in a new tab)",
    waMessage: "Hello, I had a question",
    logoAlt: "PontePie logo",
    legalNav: "Legal information",
    privacy: "Privacy",
    legal: "Legal notice",
    cookies: "Cookies",
  },
  index: {
    title: "PontePie - Podiatry clinic in Pontedeume",
    lead: "PontePie — podiatry clinic with Cristina Vila Portela",
    book: "Book appointment",
    services: "View services",
    colegiada: "Licence no.: 1193",
    photoClinic: "Interior of the PontePie clinic",
    photoCare: "Podiatry care for a patient",
    hours: "Opening hours",
    hoursLead: "By appointment · Pontedeume",
    monThu: "Monday to Thursday",
    friday: "Friday",
    morning: "Morning",
    afternoon: "Afternoon",
    closed: "Closed",
    bookOnline: "Book online",
  },
  services: {
    title: "PontePie services",
    intro: "Choose the visit you need. From here you can start booking with that service already selected.",
    duration: "Typical duration: {duration}",
    bookThis: "Book this service",
    primera: {
      title: "First consultation",
      desc: "Full assessment, gait analysis and a personalised initial plan.",
    },
    consulta: {
      title: "Follow-up / review",
      desc: "Progress check, treatment adjustment and recommendations.",
    },
    tratamiento: {
      title: "Treatment",
      desc: "Treatment session to ease discomfort and restore mobility.",
    },
  },
  about: {
    title: "About PontePie",
    lead:
      "A podiatry clinic in Pontedeume, focused on foot care and each person’s quality of life.",
    p1: "PontePie was created to offer close, evidence-based care tailored to your needs. We work holistically: assessment, treatment and follow-up so you can walk with comfort and confidence.",
    p2before: "The clinic is run by",
    p2after:
      "(licence no. 1193), with ongoing training and a focus on prevention and patient support.",
    p3: "You can explore visit types or book an appointment easily from this website.",
    services: "View services",
    book: "Book appointment",
  },
  contact: {
    title: "Contact",
    intro:
      "PontePie — podiatry clinic in Pontedeume. Write to us or book online whenever it suits you.",
    location: "Location",
    addressName: "PontePie podiatry clinic",
    addressStreet: "Avda. Dr. Villanueva, 36, Portal 1, 1ºA",
    addressCity: "15600 Pontedeume (A Coruña)",
    maps: "Open in Google Maps",
    social: "Social and WhatsApp",
    email: "Email",
    hours: "Opening hours",
    hoursMonThu: "Monday to Thursday:",
    hoursMonThuDetail: "mornings 10:00–14:00, afternoons 16:00–20:00.",
    hoursFri: "Friday:",
    hoursFriDetail: "mornings 10:00–15:00.",
    bookTitle: "Book an appointment",
    bookText: "The quickest way is to book online with the assistant.",
    bookLink: "Go to booking",
    bookCta: "Book appointment",
    waMessage: "Hello, I had a question",
  },
  cita: {
    title: "Book your appointment at PontePie",
    introBefore: "Three steps: service, date and time, and your details. When you confirm you will get a",
    locator: "booking code",
    introAfter: "so you can manage the appointment later.",
    rail: "Booking steps",
    stepService: "Service",
    stepWhen: "Date and time",
    stepData: "Your details",
    stepDone: "Confirmation",
    wizard: "Booking assistant",
    stepOf: "Step {step} of 3",
    confirmed: "Appointment confirmed",
    progress: "Booking progress",
    progressPct: "{pct}% complete",
    chooseService: "1. Choose the service",
    chooseServiceHint: "Select an option. You can change it later by going back to this step.",
    loadingServices: "Loading services…",
    continueWhen: "Continue to date and time",
    chooseWhen: "2. Choose date and time",
    serviceLabel: "Service:",
    calendar: "Calendar",
    datePicker: "Date picker",
    loadingSlots: "Loading times…",
    emptyTitle: "No free appointments this day",
    emptyText:
      "Try another date on the calendar or come back later. If it is urgent, call us or write from the contact page.",
    slotsGroup: "Available times",
    back: "Back",
    continueData: "Continue to your details",
    confirmData: "3. Confirm your details",
    formHintBefore: "Fields marked with",
    formHintAfter: "are required. Provide at least an email or phone number.",
    returningTitle: "Have you booked before?",
    returningIntro:
      "No account needed. If you are already a patient, look up your details with the email or phone and last name you used, or restore what is saved on this device.",
    returningSaved: "This device has saved details for {name}.",
    returningUseSaved: "Use these details",
    returningNotMe: "Not me",
    returningContact: "Email or phone",
    returningContactPlaceholder: "e.g. name@email.com or 600123456",
    returningLastName: "Last name",
    returningSearch: "Find my details",
    returningFound: "Details found. Check the form and confirm the appointment.",
    returningApplied: "We filled the form with the details saved on this device.",
    errLookupNeed: "Enter an email or phone and the last name to search.",
    errLookup: "Could not look up your details",
    firstName: "First name",
    lastName: "Last name",
    email: "Email",
    phone: "Phone",
    notes: "Comments",
    optional: "(optional)",
    confirming: "Confirming…",
    confirm: "Confirm appointment",
    successTitle: "Booking confirmed",
    successIntro: "Your appointment is booked. Note down or screenshot your booking code:",
    locatorAria: "Booking code {code}",
    successHint: "You will need it to cancel or reschedule from this same page, below.",
    summaryService: "Service",
    summaryWhen: "Date and time",
    summaryStatus: "Status",
    bookAnother: "Book another appointment",
    manageTitle: "Manage an existing appointment",
    manageIntro:
      "Enter the booking code and last name. To reschedule, first load free slots (same calendar as booking) and pick a time. To cancel, you can use the button with or without loading times.",
    manageLocator: "Booking code",
    manageLastName: "Last name",
    cancelReason: "Cancellation reason",
    looking: "Searching…",
    loadSlots: "Show times to reschedule",
    found: "Appointment found",
    currentDate: "Current date",
    cannotReschedule:
      "A cancelled appointment cannot be rescheduled. You can book a new one with the assistant above.",
    newWhen: "New date and time",
    sameType: "Only free slots for the same visit type as your current appointment are shown.",
    emptyReschedule:
      "Try another date. Your current slot is not counted as busy when looking for a new time.",
    rescheduleReason: "Reason for rescheduling",
    reschedulePlaceholder: "E.g. work conflict, change of availability…",
    processing: "Working…",
    cancelBtn: "Cancel appointment",
    rescheduleBtn: "Reschedule appointment",
    errNetwork: "Network error",
    errServices: "Could not load services",
    errSlots: "Could not load availability",
    errPreview: "Could not verify the appointment",
    errNeedLocator: "Enter the booking code and last name to load times.",
    errName: "First and last name are required.",
    errContact: "Provide at least an email or phone number.",
    errNeedSlot: "Select a time before confirming.",
    errBook: "Could not complete the booking",
    errNeedManage: "Enter the booking code and last name.",
    errNeedNewSlot: "Load available times and choose a new date and time.",
    errCancel: "Could not cancel the appointment",
    errReschedule: "Could not reschedule the appointment",
    errManage: "Could not update the appointment",
    cancelledOk: "Appointment {code} cancelled.",
    rescheduledOk: "Appointment {code} rescheduled for {when}.",
    privacyConsent:
      "I have read the privacy information and consent to processing my data to manage the appointment.",
    privacyPrefix: "You can read the",
    privacyLink: "privacy policy",
    errPrivacy: "You must accept the privacy information to confirm the booking.",
    errEmail: "The email address is not valid.",
    companyHoneypot: "Leave empty",
  },
  notFound: {
    title: "We cannot find this page",
    body: "This address does not exist or has moved. Go home to book or view services.",
    home: "Back to home",
  },
  legal: {
    metaDesc:
      "Privacy policy, legal notice and cookies for PontePie, a podiatry clinic in Pontedeume.",
    lastUpdated: "Last updated: 28 August 2026.",
    intro:
      "PontePie is Cristina Vila Portela’s podiatry practice in Pontedeume. These pages identify the controller, how data is used and the terms of the website.",
    privacyH1: "Privacy policy",
    noticeH1: "Legal notice",
    cookiesH1: "Cookie policy",
    controller: "Data controller",
    controllerBody:
      "{name} (trading as {trade}), licence no. {collegiate} of the {college}. Professional address: {address}. Phone: {phone}. Privacy email: {email}. Health-care register: {sanitary}.",
    nifKnown: "Tax ID (NIF): {nif}.",
    nifUnknown:
      "The holder’s tax ID appears on invoices and is provided to authorities and to anyone who requests it with a legitimate reason at {email}. It is not published here because it is not in public sources.",
    purpose: "Purpose",
    purposeBody:
      "To manage appointments, contact and, when you book or attend, the clinical record linked to your care (health data). We also send booking confirmation, cancellation and reminders if you gave us an email.",
    legalBasis: "Legal basis",
    legalBasisBody:
      "Providing health care and pre-contractual steps (booking). Consent you tick on the booking form. Legal duties for clinical records and invoicing.",
    rights: "Rights",
    rightsBody:
      "You may request access, rectification, erasure, restriction, portability or objection at {email}. You may also lodge a complaint with the Spanish DPA (aepd.es).",
    retention: "Retention",
    retentionBody:
      "Clinical records are kept for at least 5 years from the last visit, under Spanish Law 41/2002. Appointment and contact data are kept as long as needed for the diary, claims and tax duties (typically up to 5 years).",
    processors: "Processors",
    processorsBody:
      "Database hosting: Neon (PostgreSQL). If email is configured, messages are sent by SMTP. We do not sell your data or run behavioural advertising.",
    transfers: "International transfers",
    transfersBody:
      "Neon may host the database in the EU or another region depending on the project. We do not send data to advertising analytics services.",
    owner: "Site owner",
    ownerBody:
      "The site {site} is owned by {name}, trading as {trade}. Address: {address}. Email: {email}. Phone: {phone}. Licence no.: {collegiate} ({college}). Health-care register: {sanitary}.",
    sanitary: "Health-care authorisation",
    sanitaryBody:
      "Podiatry practice with health-care register number {sanitary} (Galicia, Spain).",
    liability: "Liability",
    liabilityBody:
      "Website information is indicative and does not replace an in-person visit. Slot availability can change until the booking is confirmed. Content may only be used to learn about the clinic or to book.",
    cookiesWhat: "Technologies we use",
    cookiesBody:
      "We do not use advertising or marketing-analytics cookies. Only necessary local storage for language and the internal admin session.",
    cookiesList: "Details",
    cookieLang: "pontepie_lang: interface language (necessary).",
    cookieAdmin: "pontepie_admin_token: staff session on /admin (necessary for the panel).",
    cookieConsent: "pontepie_cookie_consent: remembers whether you accepted the cookie notice (necessary).",
    cookieSentry:
      "Sentry: production error diagnosis. Not used for advertising. May include technical browser identifiers.",
  },
  cookieBanner: {
    message:
      "We use first-party cookies for the website to work (language, cookie notice and, where applicable, admin session). You can read more in our",
    accept: "Accept",
    policy: "cookie policy",
  },
  status: {
    pending: "Pending",
    confirmed: "Confirmed",
    cancelled: "Cancelled",
    completed: "Completed",
    no_show: "No-show",
  },
};

export const dictionaries: Record<Lang, Dict> = { es, gl, en };

export const SERVICE_IDS = {
  PRIMERA_CONSULTA: "primera",
  CONSULTA: "consulta",
  TRATAMIENTO: "tratamiento",
} as const;
